/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PaginatedResponseBodyGeneric } from './paginated-response-body-generic';
import { ResponseWithErrorGeneric } from './response-with-error-generic';
import { IResponseWithErrorGeneric } from './iresponse-with-error-generic.interface';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class PaginatedResponseWithErrorGeneric<TBody extends PaginatedResponseBodyGeneric<TResult>, TResult> extends ResponseWithErrorGeneric<TBody, TResult> implements IResponseWithErrorGeneric<TResult> {
  public page: number = undefined;
  public pageCount: number = undefined;
  public pageSize: number = undefined;
  public totalCount: number = undefined;

  //<custom-body>
  constructor(response: HttpResponse<ResponseWithErrorGeneric<TBody, TResult>>, defaultResult: TResult){
    super(response, defaultResult);
    this.page= this.body.page;
    this.pageCount = this.body.pageCount;
    this.pageSize = this.body.pageSize;
    this.totalCount = this.body.totalCount;
  }
  //</custom-body>
}
